import $ from 'jquery'

const setScrollBarWidth = () => {
  document.body.style.setProperty(
    '--scrollbar-width',
    window.innerWidth - document.documentElement.clientWidth + 'px'
  )
}

window.addEventListener('load', setScrollBarWidth)
window.addEventListener('resize', setScrollBarWidth)

// Fix autocomplete wrong width calculation.
$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}
